import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type StackManageScheduledDeleteConfirmationModalProps = {
  onConfirm: () => void;
};

const StackManageScheduledDeleteConfirmationModal = create(
  function StackManageScheduledDeleteConfirmationModal({
    onConfirm,
  }: StackManageScheduledDeleteConfirmationModalProps) {
    const modal = useModal();

    const handleOnConfirm = () => {
      modal.resolve();
      modal.hide();
      onConfirm();
    };

    return (
      <ConfirmationModal
        title="Delete scheduling"
        confirmationButtonLabel="Delete"
        confirmationButtonVariant="dangerPrimary"
        onConfirm={handleOnConfirm}
      >
        <ConfirmationModalMessage>
          Are you sure you want to delete <strong>Delete stack</strong> scheduling?
        </ConfirmationModalMessage>
      </ConfirmationModal>
    );
  }
);

export const showStackManageScheduledDeleteConfirmationModal = (
  props: StackManageScheduledDeleteConfirmationModalProps
) => show(StackManageScheduledDeleteConfirmationModal, props);
